import {List} from 'immutable'
const get = (state) => state.get('discount', List()) ;

export default {
    get
}



// WEBPACK FOOTER //
// src/model/DiscountCode/selector.js